/* MOFUCAT 2026-10-08 トップの作り直し（見本 A）の小さな動き。
   ・一番上の写真: 数秒ごとに切り替わる（動きを減らす設定の人・画面を見ていない時は止める）。点を押す・左右になぞると替わる。
   ・右下の黒猫の浮きボタン: 少し下へ進んだら出る（最初の画面の字にかぶらない）。押すとメールの登録の小窓を開く
     （小窓が無い時はページの下のメールの登録へ）。カート・お会計・ほかのボタンには触らない。 */
(function () {
  function still() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function hero(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var slides = root.querySelectorAll('.mt-hero__slide');
    var dots = root.querySelectorAll('.mt-hero__dot');
    if (slides.length < 2) return;
    var i = 0, timer = null, every = (parseInt(root.dataset.every, 10) || 5) * 1000;
    function show(n) {
      i = (n + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function (s, k) {
        s.classList.toggle('is-on', k === i);
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      Array.prototype.forEach.call(dots, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (!still() && !document.hidden) timer = setInterval(function () { show(i + 1); }, every);
    }
    Array.prototype.forEach.call(dots, function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    var box = root.querySelector('.mt-hero__slides'), x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); start(); }
    }, { passive: true });
    document.addEventListener('visibilitychange', start);
    show(0);
    start();
  }

  function floatButton(btn) {
    if (btn.dataset.ready) return;
    btn.dataset.ready = '1';
    btn.hidden = false;
    var after = parseInt(btn.dataset.after, 10) || 0, ticking = false;
    function update() {
      ticking = false;
      btn.classList.toggle('is-away', window.scrollY < after);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
    btn.addEventListener('click', function () {
      if (document.getElementById('MofucatNlPopup')) {
        document.dispatchEvent(new CustomEvent('mofucat:nl-open'));
        return;
      }
      var mail = document.getElementById(btn.dataset.fallback || '');
      if (mail) mail.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'center' });
    });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mt-hero]'), hero);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mt-float]'), floatButton);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
